import { render, staticRenderFns } from "./Redirect.vue?vue&type=template&id=607dca0c&scoped=true"
import script from "./Redirect.vue?vue&type=script&lang=js"
export * from "./Redirect.vue?vue&type=script&lang=js"
import style0 from "./Redirect.vue?vue&type=style&index=0&id=607dca0c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607dca0c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('607dca0c')) {
      api.createRecord('607dca0c', component.options)
    } else {
      api.reload('607dca0c', component.options)
    }
    module.hot.accept("./Redirect.vue?vue&type=template&id=607dca0c&scoped=true", function () {
      api.rerender('607dca0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Redirect.vue"
export default component.exports